/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { ComponentProps, forwardRef } from 'react';
import { useField } from 'formik';
import Tick from '@/assets/svgs/defaultTick';
import { colors } from '@airwallex/global';
import { containerCss, checkboxCss, checkboxInputCss, checkboxLabelCss } from './styles';

interface CheckboxProps {
  name: string;
  isDisabled?: boolean;
  label?: React.ReactNode;
  value?: string | boolean;
  error?: React.ReactNode;
}

const Index = forwardRef<HTMLInputElement, CheckboxProps & ComponentProps<'input'>>((props, ref) => {
  const { label, value, name, isDisabled = false, className, ...others } = props;
  const [field] = useField(props);
  const checked = () => {
    if (Array.isArray(field.value)) {
      return field.value.includes(value);
    }
    return !!field.value;
  };
  return (
    <div css={containerCss} className={className}>
      <span css={checkboxCss(checked())}>
        <input
          checked={checked()}
          type="checkbox"
          ref={ref}
          {...field}
          {...others}
          value={value}
          css={checkboxInputCss(isDisabled)}
        />
        {checked() && <Tick color={colors.white} />}
      </span>
      <span css={checkboxLabelCss}>{label}</span>
    </div>
  );
});

Index.displayName = 'checkbox';
export default Index;
